import React from 'react';
import CHSHGame from './components/CHSHGame';
import './App.css';

function App() {
  return (
    <div className="App">
      <CHSHGame />
    </div>
  );
}

export default App;